import { render, staticRenderFns } from "./modal-editnonapprover.vue?vue&type=template&id=1b751ca6&scoped=true&"
import script from "./modal-editnonapprover.vue?vue&type=script&lang=js&"
export * from "./modal-editnonapprover.vue?vue&type=script&lang=js&"
import style0 from "./modal-editnonapprover.vue?vue&type=style&index=0&id=1b751ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b751ca6",
  null
  
)

export default component.exports